import React from "react";

export default function AuthCard({
  title,
  description,
  children,
  className = "",
}) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo/Brand */}
        <div className="text-center">
          <h1 className="text-3xl font-bold text-orange-600 mb-2">
            BuildBright
          </h1>
          <p className="text-sm text-gray-600">
            Professional Contractor Platform
          </p>
        </div>

        {/* Title and Description */}
        <div className="mt-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
          {description && (
            <p className="mt-2 text-sm text-gray-600">{description}</p>
          )}
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div
          className={`bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 ${className}`}
        >
          {children}
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <p className="text-xs text-gray-500">
          Need help? Contact{" "}
          <a
            href="mailto:support@buildingbright.app"
            className="text-orange-600 hover:text-orange-500"
          >
            support@buildingbright.app
          </a>
        </p>
      </div>
    </div>
  );
}
